import home from '@/sfc/home/index.vue';
import product from '@/sfc/product/index.vue';
import news from '@/sfc/news/index.vue';
import about from '@/sfc/about/index.vue';
import contact from '@/sfc/contact/index.vue';
import history from '@/sfc/about/history.vue';
import joinus from '@/sfc/about/join-us.vue';
import partners from '@/sfc/about/partners.vue';
import eventinfo from '@/sfc/product/event-info.vue';
import detail from '@/sfc/product/pro-detail.vue';
import pweather from '@/sfc/product/p-weather.vue';
import ptrack from '@/sfc/product/p-track.vue';
import prouting from '@/sfc/product/p-routing.vue';
import pportinfo from '@/sfc/product/p-portinfo.vue';
import pinfo from '@/sfc/product/p-info.vue';
import pcases from '@/sfc/product/cases.vue';
import portservicescreen from "@/sfc/product/port-service-screen.vue";
import portinfometeo from "@/sfc/product/port-info-meteo.vue";
import nweather from '@/sfc/news/n-weather.vue';
import nship from '@/sfc/news/n-ship.vue';
import ncom from '@/sfc/news/n-com.vue';
import kmeteo from '@/sfc/knows/k-meteo.vue';
import kship from '@/sfc/knows/k-ship.vue';
import onlineResume from '@/sfc/about/online-resume.vue';
//产品详情
import advisoryservice from '@/sfc/product/advisory-service.vue';
import areainfo from '@/sfc/product/area-info.vue';
import meteoservice from '@/sfc/product/meteo-service.vue';
import routedesign from '@/sfc/product/route-design.vue';
import shiptrack from '@/sfc/product/ship-track.vue';
import shipwarning from '@/sfc/product/ship-warning.vue';
import weatherroute from '@/sfc/product/weather-route.vue';
import portinfo from '@/sfc/product/port-info.vue';
var routers = [
    { path: '/', redirect: 'home' },
    {
        path: '/home',
        name: 'home',
        meta: {
            requiresAuth: false
        },
        component: home
    },
    {
        path: '/product',
        name: 'product',
        meta: {
            requiresAuth: false
        },
        component: product,
    },
    {
        path: '/pweather',
        name: 'pweather',
        meta: {
            requiresAuth: false
        },
        component: pweather,
    },
    {
        path: '/ptrack',
        name: 'ptrack',
        meta: {
            requiresAuth: false
        },
        component: ptrack,
    },
    {
        path: '/prouting',
        name: 'prouting',
        meta: {
            requiresAuth: false
        },
        component: prouting,
    },
    {
        path: '/pinfo',
        name: 'pinfo',
        meta: {
            requiresAuth: false
        },
        component: pinfo,
    },
    {
        path: '/pportinfo',
        name: 'pportinfo',
        meta: {
            requiresAuth: false
        },
        component: pportinfo,
    },
    {
        path: '/detail',
        name: 'detail',
        component: detail,
        meta: {
            requiresAuth: false
        },
    },
    {
        path: '/portinfo',
        name: 'portinfo',
        component: portinfo,
        meta: {
            requiresAuth: false
        },
    },
    {
        path: '/pcases',
        name: 'pcases',
        component: pcases,
        meta: {
            requiresAuth: false
        },
    },
    {
        path: '/weatherroute',
        name: 'weatherroute',
        component: weatherroute,
        meta: {
            requiresAuth: false
        },
    },
    {
        path: '/shipwarning',
        name: 'shipwarning',
        component: shipwarning,
        meta: {
            requiresAuth: false
        },
    },
    {
        path: '/shiptrack',
        name: 'shiptrack',
        component: shiptrack,
        meta: {
            requiresAuth: false
        },
    },
    {
        path: '/routedesign',
        name: 'routedesign',
        component: routedesign,
        meta: {
            requiresAuth: false
        },
    },
    {
        path: '/meteoservice',
        name: 'meteoservice',
        component: meteoservice,
        meta: {
            requiresAuth: false
        },
    },
    {
        path: '/areainfo',
        name: 'areainfo',
        component: areainfo,
        meta: {
            requiresAuth: false
        },
    },
    {
        path: '/eventinfo',
        name: 'eventinfo',
        component: eventinfo,
        meta: {
            requiresAuth: false
        },
    },
    {
        path: '/portservicescreen',
        name: 'portservicescreen',
        component: portservicescreen,
        meta: {
            requiresAuth: false
        },
    },
    {
        path: '/portinfometeo',
        name: 'portinfometeo',
        component: portinfometeo,
        meta: {
            requiresAuth: false
        },
    },
    {
        path: '/advisoryservice',
        name: 'advisoryservice',
        component: advisoryservice,
        meta: {
            requiresAuth: false
        },
    },
    {
        path: '/news',
        name: 'news',
        meta: {
            requiresAuth: false
        },
        component: news
    },
    {
        path: '/nweather',
        name: 'nweather',
        meta: {
            requiresAuth: false
        },
        component: nweather
    },
    {
        path: '/nship',
        name: 'nship',
        meta: {
            requiresAuth: false
        },
        component: nship
    },
    {
        path: '/ncom',
        name: 'ncom',
        meta: {
            requiresAuth: false
        },
        component: ncom
    },
    {
        path: '/about',
        name: 'about',
        meta: {
            requiresAuth: false
        },
        component: about
    },
    {
        path: '/contact',
        name: 'contact',
        meta: {
            requiresAuth: false
        },
        component: contact
    },
    {
        path: '/history',
        name: 'history',
        meta: {
            requiresAuth: false
        },
        component: history
    },
    {
        path: '/joinus',
        name: 'joinus',
        meta: {
            requiresAuth: false
        },
        component: joinus
    },
    {
        path: '/partners',
        name: 'partners',
        meta: {
            requiresAuth: false
        },
        component: partners
    },
    {
        path: "/kmeteo",
        name: 'kmeteo',
        meta: {
            requiresAuth: false
        },
        component: kmeteo
    },
    {
        path: "/kship",
        name: 'kship',
        meta: {
            requiresAuth: false
        },
        component: kship
    },
    {
        path: "/resume",
        name: "resume",
        meta: {
            requiresAuth: false
        },
        component: onlineResume
    }
];
var pathMap = new Map();
/*um.map(value => setPathAuth("/",value));
function setPathAuth(basePath:string,config:RouteConfig){

  if(config.meta)
    pathMap.set(basePath+config.path,config.meta.auth)
  if(config.children)
    config.children.map(value => setPathAuth(basePath+config.path,value));
}*/
export function getAuthByPath(path) {
    var re = pathMap.get(path);
    return re;
}
export default routers;



//////////////////
// WEBPACK FOOTER
// ./src/router/routers/index.ts
// module id = null
// module chunks = 